import { API_BASE_URL, API_PATHS, getApiPaths } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class OrganizationService {

    static getOrganization(item) {

        let api = `${API_BASE_URL}${API_PATHS.getOrganization}`;

        const params = new URLSearchParams();

        if (item?.page) params.append("page", item.page);
        if (item?.limit) params.append("limit", item.limit);
        if (item?.id) params.append("id", item.id);
        if (item?.usertype) params.append("usertype", item.usertype);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api,item);
    }

    static addOrganization(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addOrganization}`;
        return axiosInstance
            .post(api, data)

    }

    static editOrganization(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.editOrganization}`;
        return axiosInstance
            .put(api, data)

    }

    static deleteOrganization(id) {
        let api = '';

        api = `${API_BASE_URL}${API_PATHS.deleteOrganization}?id=${id}`;

        return axiosInstance
            .delete(api)
    }


}

export default OrganizationService;
